const API_URL = '/api/historialventas';

/**
 * Obtiene la lista de todas las cabeceras de ventas registradas.
 */
export const getHistorialVentas = async () => {
    try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error('Error al obtener el historial de ventas');
        return await response.json();
    } catch (error) {
        console.error("VentaService - getHistorialVentas:", error);
        return [];
    }
};

/**
 * Obtiene el detalle de artículos de una venta específica por su ID.
 * @param {number|string} idVenta 
 */
export const getDetalleVenta = async (idVenta) => {
    try {
        const response = await fetch(`${API_URL}?id=${idVenta}`);
        if (!response.ok) throw new Error('Error al obtener el detalle de la venta');
        return await response.json();
    } catch (error) {
        console.error("VentaService - getDetalleVenta:", error);
        return [];
    }
};

